import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

// reducers
import activity from './reducers/activity';
import baskets from './reducers/baskets';
import sofologist from './reducers/sofologist';
import eventFeed from './reducers/eventFeed';
import user from './reducers/user';
import order from './reducers/order'

export default combineReducers({
  routing: routerReducer,
  activity,
  baskets,
  eventFeed,
  sofologist,
  user,
  order
});



// WEBPACK FOOTER //
// ./src/rootReducer.js